import { mapNotificationTypeFromDTO } from '@/modules/common/mappers/notification-type.mapper';

import { Notification, NotificationResponse } from '../types';

/**
 * Maps NotificationResponse DTO to domain Notification model.
 */
export const mapNotificationFromResponse = (response: NotificationResponse): Notification => ({
  id: response.id,
  type: mapNotificationTypeFromDTO(response.type),
  args: response.args,
  actionArgs: response.actionArgs,
  createdAt: new Date(response.createdAt),
  updatedAt: response.updatedAt ? new Date(response.updatedAt) : null,
  isRead: response.isRead,
});

/**
 * Maps array of NotificationResponse DTOs to domain Notification models.
 */
export const mapNotificationsFromResponse = (responses: NotificationResponse[]): Notification[] =>
  responses.map(mapNotificationFromResponse);
